<template>
<div class="tab-pane active" id="step2">
	<h2 class="hidden-lg">{{ $t("tab.booth_selection") }}</h2>
	<div class="row">
		<div class="booth-selector-block col-md-12 clear ">
			<h4>{{ $t("labels.select_booth_package") }}:</h4>
			<div id="list-type" class="row display-flex proerty-th">
				<div v-for="booth in booths" :key="booth.id" class="col-md-4 col-sm-6 col-xs-12 p0">
					<Booth :booth="booth" @selected="setDisplayBooth" />
				</div>
			</div>
    </div>
		<div class="col-md-12" v-if="!isExhibitionClosed">
			<hr>
			<div class="wizard-footer">
				<div v-show="views.boothSetup.displayBooth != null" class="pull-right">
					<input
						type='button'
						class='btn btn-next btn-warning btn-next-booth-selector'
						name='next'
						:value='($t("tab.booth_set_up") + " " + $t("buttons.next_to"))'
						@click="store.updateCurrentTab('booth_setup')"/>
				</div>
				<div v-if="views.boothSetup.displayBooth == null" class="pull-right">
					<input
						type='button'
						class='btn btn-next btn-warning btn-articles-selector'
						name='skip'
						:value='($t("tab.articles") + " " + $t("buttons.next_to"))'
						@click="skipToArticles"/>
				</div>
				<div class="pull-left">
					<input
						type='button'
						class='btn btn-previous btn-warning'
						name='previous'
						:value='($t("buttons.prev_to") + " " + $t("tab.key_data"))'
						@click="store.updateCurrentTab('key_data')"/>
				</div>
				<div class="clearfix"></div>
			</div>
		</div>
	</div>
</div>
</template>

<script setup>
import { useMainStore } from '@/store'
import Booth from './configurator/Booth.vue'

const store = useMainStore()
// define passed props
const props = defineProps({
	basket: {
		type: Object,
		required: true,
	},
	booths: {
		type: Array,
		default: [],
	},
	views: {
		type: Object,
		required: true,
	},
	isExhibitionClosed: {
		type: Boolean,
		required: false,
	},
})
// define emits
const emit = defineEmits(['resetDisplayedBooth'])

// define methods
const setDisplayBooth = (booth) => {
	store.tmp.selected_booth = booth
	store.updateCurrentTab('booth_setup')
	$('.btn-next-booth-selector').click()
}

const skipToArticles = () => {
	emit('resetDisplayedBooth', 'articles')
	$('.btn-articles-selector').click()
}
</script>
